import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useScaleApplication } from "@/domains/application/use-scale-application"

/**
 * Hook to navigate to /lock when the selected lock is cleared (becomes null).
 * This handles the case where a lock is transferred or withdrawn while viewing a sub-page.
 */
export function useNavigateOnLockCleared(): void {
  const location = useLocation()
  const navigate = useNavigate()
  const scaleApp = useScaleApplication()

  useEffect(() => {
    // Only navigate if we're on a lock sub-page (matches /lock/:id/*)
    const isLockSubPage = /^\/lock\/[^/]+/.test(location.pathname)
    if (!isLockSubPage) {
      return
    }

    const selectedLockId = scaleApp.Pages.Lock.selectedLockId
    if (selectedLockId === null) {
      navigate("/lock")
    }
  }, [scaleApp.Pages.Lock.selectedLockId, location.pathname, navigate])
}

